import { render, staticRenderFns } from "./StockJournalRoles.vue?vue&type=template&id=4d11c220"
import script from "./StockJournalRoles.vue?vue&type=script&lang=js"
export * from "./StockJournalRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports